// extracted by mini-css-extract-plugin
export default {"top_sec":"style_top_sec__lv+aI","item":"style_item__AfMfy"};